import { resolveFields } from '../Fields';
import { MyForestPost } from '../../types';
import ArticleContainer from '../ArticleContainer';
import Breadcrumb from '../Breadcrumb';
import TeaserHeroFull from '../TeaserHeroFull';
import { BlockRenderer } from '../Fields/BlockRenderer';

const MyForest = ({ fields }: MyForestPost) => {
  const [hero, contentFields] = resolveFields(fields);

  return (
    <ArticleContainer>
      <Breadcrumb zIndex="1" gridRow="1" mb="auto" color="white" />
      {hero && <TeaserHeroFull gridRow="1" {...hero} />}
      <BlockRenderer blocks={contentFields} />
    </ArticleContainer>
  );
};

export default MyForest;
